export const getWalkIn = (state) => state.walkIn.data;
export const getWalkInPendingSelector = (state) => state.walkIn.pending;
